module.exports = __webpack_public_path__ + "static/assets/21ab6e16ff6a06bab4f5a519aaa74b6a.svg";